define('presentation/signup/viewModels/signupPhoneNumberTypeViewModel',[
    'common/promises/promiseFactory',
    'common/storage/workSessionIdStorage',
    'common/url/urlFormatter',
    'constants/numberPickerConstants',
    'constants/signupNumberIntentConstants',
    'presentation/signup/common/signupNavigationManager',
    'presentation/signup/facades/signupPhoneNumberTypeFacade',
], function() {

    return function() {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');

        const _numberPickerConstants = require('constants/numberPickerConstants');
        const _signupNumberIntentConstants = require('constants/signupNumberIntentConstants');
        const _urlFormatter = require('common/url/urlFormatter');
        const _workSessionIdStorage = require('common/storage/workSessionIdStorage');

        const _isSignupForCustomer = _workSessionIdStorage.getWorkSessionId() !== null && _workSessionIdStorage.getWorkSessionId() !== undefined;

        let _facade = null;
        let _signupNavigationManager = null;
        let _signupSession = null;

        self.headingText = _i18n.t('signupPhoneNumberType:headingText');
        self.subtitleText = _i18n.t('signupPhoneNumberType:subtitleText');

        self.isSignupForCustomer = ko.observable(_isSignupForCustomer);
        self.isCompositionComplete = ko.observable(false);
        self.isScrollActive = ko.observable(false);
        self.isOnNumberIntentStep = ko.observable(true);
        self.isOnNumberTypeStep = ko.observable(false);

        self.selectedCard = ko.observable(null);

        self.homeUrl = _urlFormatter.buildFrontendUrl("/");

        self.numberCards = ko.pureComputed(() => {
            return [
                createCard('forward', 'forwardTitle', 'forwardMessage', 'phoneForward'),
                createCard('new', 'newTitle', 'newMessage', 'phoneAdd'),
            ];
        });

        self.numberTypeCards = ko.pureComputed(() => {
            return [
                createCard('local', 'localTitle', 'localMessage', 'signupNumberLocal'),
                createCard('tollFree', 'tollFreeTitle', 'tollFreeMessage', 'signupNumberTollfree'),
            ];
        });

        const createCard = (type, title, description, icon) => ({
            type,
            title,
            description,
            icon,
            isSpinning: ko.observable(false),
            onClick: (card) => self.onCardClick(card),
        });

        const _navigateToNumberIntentStep = () => {
            self.isOnNumberTypeStep(false);
            self.isOnNumberIntentStep(true);
            self.selectedCard(null);
        };

        const _navigateToNumberTypeStep = () => {
            self.isOnNumberIntentStep(false);
            self.isOnNumberTypeStep(true);
            self.selectedCard(null);
        };

        const _handleNumberTypeCleanup = () => {
            return _promiseFactory.defer((promise) => {
                const isNumberPort = _signupSession.numberTypeSelection === _numberPickerConstants.numberTypes.port;
                if (isNumberPort) {
                    const numberPortId = _signupSession.numberPort ? _signupSession.numberPort.numberPortId : null;
                    if (numberPortId === null) {
                        promise.resolve();
                    } else {
                        _facade.clearPortForm(numberPortId)
                            .fail(promise.reject)
                            .done(promise.resolve);
                    }
                } else {
                    const reservedPhoneNumber = _signupSession.reservedPhoneNumber;
                    if (reservedPhoneNumber === null || reservedPhoneNumber === undefined) {
                        promise.resolve();
                    } else {
                        _facade.cancelPhoneNumberReservation(reservedPhoneNumber)
                            .fail(promise.reject)
                            .done(promise.resolve);
                    }
                }
            });
        };

        const _handleNumberTypeSelection = () => {
            return _promiseFactory.defer((promise) => {
                _handleNumberTypeCleanup()
                    .fail(promise.reject)
                    .done(() => {
                        _facade.storeBypassNumberSelection(false);
                        _facade.saveNumberTypeSelection(self.selectedCard())
                            .fail(promise.reject)
                            .done(() => {
                                promise.resolve();
                                _signupNavigationManager.nextPage();
                            });
                    });
            });
        };

        const _handleForwardNumberIntentSelection = () => {
            return _promiseFactory.defer((promise) => {
                _handleNumberTypeCleanup()
                    .fail(promise.reject)
                    .done(() => {
                        _facade.storeBypassNumberSelection(true);
                        _facade.saveNumberTypeSelection(null)
                            .fail(promise.reject)
                            .done(() => {
                                _facade.saveNumberIntentSelection(_signupNumberIntentConstants.forward)
                                    .fail(promise.reject)
                                    .done(() => {
                                        _facade.setPhoneNumberCompleted()
                                            .fail(promise.reject)
                                            .done(() => {
                                                _signupNavigationManager.nextPage();
                                                promise.resolve(true);
                                            });
                                    });
                            });
                    });
            });
        };

        const _hasOnlyTelephonyPackage = () => {
            return !!_signupSession.telephonyPackageId &&
                !_signupSession.liveReceptionistPackageId &&
                !_signupSession.webChatPackageId &&
                !_signupSession.outboundCallingPackageId;
        };

        self.onCardClick = (card) => {
            card.isSpinning(true);

            const releaseSpinnerOnFailure = (operation) => operation.fail(() => card.isSpinning(false));

            if (self.isOnNumberIntentStep()) {
                if (card.type === 'forward') {
                    releaseSpinnerOnFailure(_handleForwardNumberIntentSelection());
                } else if (card.type === 'new') {
                    _navigateToNumberTypeStep();
                    card.isSpinning(false);
                }
            } else if (self.isOnNumberTypeStep()) {
                self.selectedCard(_numberPickerConstants.numberTypes[card.type]);
                releaseSpinnerOnFailure(_handleNumberTypeSelection());
            }
        };

        self.onAgentBypassClicked = () => {
            return _promiseFactory.defer((promise) => {
                _facade.storeBypassNumberSelection(true);
                _facade.saveNumberTypeSelection(null)
                    .fail(promise.reject)
                    .done(() => {
                        _facade.saveNumberIntentSelection(null)
                            .fail(promise.reject)
                            .done(() => {
                                _facade.setPhoneNumberCompleted()
                                    .fail(promise.reject)
                                    .done(() => {
                                        promise.resolve(true);
                                    });
                            });
                    });
            });
        };

        self.onBackArrowClicked = () => {
            return _promiseFactory.defer((promise) => {
                if (self.isOnNumberIntentStep()) {
                    _facade.storeBypassNumberSelection(false);
                    promise.resolve();
                    _signupNavigationManager.previousPage();
                } else {
                    _facade.saveNumberTypeSelection(null)
                        .fail(promise.reject)
                        .done(() => {
                            promise.resolve();
                            if (_hasOnlyTelephonyPackage()) {
                                _signupNavigationManager.previousPage();
                            } else {
                                _navigateToNumberIntentStep();
                            }
                        });
                }
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.detached = function() {
            _signupNavigationManager.detached();
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/signup/facades/signupPhoneNumberTypeFacade');
            _facade = new FacadeConstructor();
            _facade.init();

            const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
            _signupNavigationManager = new SignupNavigationManagerConstructor();
            _signupNavigationManager.init();

            return _initialize();
        };

        const _initialize = () => {
            _promiseFactory.deferIndefinitely(promise => {
                _facade.loadSignupSession()
                    .done((signupSession) => {
                        _signupSession = signupSession;

                        if (_hasOnlyTelephonyPackage()) {
                            _navigateToNumberTypeStep();
                        }

                        promise.resolve();
                    });

                return _promiseFactory.wait();
            });
        };
    };
});
